module.exports = __webpack_public_path__ + "5c9bf9c96dd0a4a0cf3a634f23df65b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/recomment2.png
// module id = 3280
// module chunks = 0